import { render, staticRenderFns } from "./liveaboardcomment.vue?vue&type=template&id=7d406de1&scoped=true&"
import script from "./liveaboardcomment.vue?vue&type=script&lang=js&"
export * from "./liveaboardcomment.vue?vue&type=script&lang=js&"
import style0 from "./liveaboardcomment.vue?vue&type=style&index=0&id=7d406de1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d406de1",
  null
  
)

export default component.exports